import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
import AriaTablist from 'aria-tablist';
import BigPicture from 'bigpicture';
import gsap from 'gsap';

const BESTPARTNERS = {

  headerScroll: function() {
    
    const header =  document.getElementById('header');
    const headerMenuCenter = document.getElementById('headerMenuCenter');
    let y = window.scrollY;
    
    if (y >= 300) {
      header.classList.add('js-fix-header');
      headerMenuCenter.classList.remove('u-display-none');
    } else {
       header.classList.remove('js-fix-header');
       headerMenuCenter.classList.add('u-display-none');
    }
    
  },

  offScreenNav: function() {

    const siteMenu = document.getElementById('siteMenu');
    const menuButton = document.getElementById('menuButton');
    const header = document.getElementById('header');
    const body = document.body;

    menuButton.addEventListener('click', (e)=>{
      e.preventDefault();
      siteMenu.classList.toggle('u-display-none');
      menuButton.classList.toggle('is-active');
      body.classList.toggle('u-overflow-hidden');
      header.classList.toggle('js-open-menu');

    });

  },

  headerHover: function() {

    document.querySelectorAll('.off-screen-nav__row').forEach(item => {
      item.addEventListener('mouseenter', event => {
        event.target.classList.add("js-menu-opacity");
      })
    })

    document.querySelectorAll('.off-screen-nav__row').forEach(item => {
      item.addEventListener('mouseleave', event => {
        event.target.classList.remove("js-menu-opacity");
      })
    })
  },

   /* globe.php */
  globeSlider: function() {

    const swiper = new Swiper('.globe-slider', {
      slidesPerView: 1, 
      speed: 1000, 
      loop: false,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      }
    });
  },
  
  /* fullwidthcarousel.php */
  swiperHorizontal: function() {

    const swiper = new Swiper('.swiper-horizontal', {
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          slidesPerGroup: 2, 
          spaceBetween: 40 

        },

        769: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        }
      },

    });
  
  },

  /* carousel-half-right.php */
  halfSwiperRight: function() {

    const swiper = new Swiper('.swiper-half-right', {
      loop: false,
      slidesPerView: 1, 
      speed: 500,    
    
      pagination: {
        el: '.swiper-pagination-vertical-wrap',
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class='bullet swiper-pagination-bullet'></div>`;
        },
      },
    
    });
  
  },

  /* carousellefttextright.php */
  swiperLeft: function() {

    const swiper = new Swiper('.swiper-left', {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  
  },

  /* carouselicons.php */
  threeSwiper: function() {

    const swiper = new Swiper('.swiper-three', {
      loop: true,
      slidesPerView: 1, 
      breakpoints: {
        1024: {
          slidesPerView: 3.01
        },
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      }
    });
  },

  /* case study / blog */
  offScreenCarosuel2: function() {

    const swiper = new Swiper('.swiper-offscreen-wrap-2', {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerView: 1.2,
      breakpoints: {
        1024: {
          slidesPerView: 2.2,
        },
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      }
    });
  },

  /* tabs.php */
  tabs: function() {
    AriaTablist(document.getElementById('tabs'));
  },


  typeText: function() {
  
    const typedTextSpan = document.querySelector('.typed-text');
    const cursorSpan = document.querySelector('.cursor');
    const pageTypingText = document.getElementById('typingText');
    const typingDelay = 200;
    const erasingDelay = 100;
    const newTextDelay = 600;
    let textArrayIndex = 0;
    let charIndex = 0;
    if(pageTypingText) {
      const textArray = JSON.parse(pageTypingText.getAttribute('data-store-text'));
      if(textArray.length !== null) setTimeout(type, newTextDelay + 200);

      function type() {
        if (charIndex < textArray[textArrayIndex].length) {
          if(!cursorSpan.classList.contains('typing')) cursorSpan.classList.add('typing');
          typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
          charIndex++;
          setTimeout(type, typingDelay);
        } 
        else {
          cursorSpan.classList.remove('typing');
          setTimeout(erase, newTextDelay);
        }
      }
  
      function erase() {
        if (charIndex > 0) {
          if(!cursorSpan.classList.contains('typing')) cursorSpan.classList.add('typing');
          typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex-1);
          charIndex--;
          setTimeout(erase, erasingDelay);
        } 
        else {
          cursorSpan.classList.remove('typing');
          textArrayIndex++;
          if(textArrayIndex>=textArray.length) textArrayIndex=0;
          setTimeout(type, typingDelay + 1000);
        }
      }
  
    } 

  },

  /* Animations */
  bigPicture: function() {

    const video = document.getElementById('video');
    const background = document.querySelector('.video-svg__bg-content');

    if(video) {
      video.addEventListener('click', function() {
        const vimeo = this.getAttribute('data-vimeo');
            BigPicture({
              el: this,
              vimeoSrc: vimeo,
            });
        });
    }

    if(background) {
      background.addEventListener('click', function() {
        const vimeo = video.getAttribute('data-vimeo');
            BigPicture({
              el: this,
              vimeoSrc: vimeo,
            });
        });

    }
  
  },

  /* animation-video.php */
  videoExpand: function() {

    var collapsedWidth, expandedWidth;
    var block = document.querySelector('.video-block');

    if (block) {
      var videoHolder = block.querySelector('.video-holder');
      var videoPreview = block.querySelector('.video-preview');
      var colLeft = block.querySelector('.video-block__col-left > *');
      var btnPlay = block.querySelector('.play-btn');
      var sizeRef = block.querySelector('.poster-size-ref');
      var player = new Vimeo.Player('vimeo-player1');

      player.on('pause', function () {
        expand(false);
      });

      btnPlay.addEventListener('click', (e) => {
        expand(true);
        e.currentTarget.parentElement.classList.add("js-hide-preview");
      });

      window.addEventListener('DOMContentReady', recalcBounds);
      window.addEventListener('resize', onResize);

      recalcBounds();
      showVideo(false);

    }

    // ------------------------------------------------------------------------------------------

    function onResize() {
      videoPreview.style = '';
      recalcBounds();
    }

    function recalcBounds() {
      expandedWidth = block.offsetWidth;
      collapsedWidth = sizeRef.offsetWidth;
    }

    function expand(st) {

      var tl = gsap.timeline();

      if (st) {
        tl
          .to(colLeft, {
            duration: .5,
            x: (collapsedWidth - expandedWidth),
            alpha: 0,
            ease: 'sine.out'
          })
          .to(videoPreview, {
            duration: .5,
            width: expandedWidth,
            ease: 'sine.out'
          }, '<')
          .add(() => {
            showVideo(true);
          }, '>')
      } else {
        showVideo(false);

        tl
          .to(colLeft, {
            duration: .5,
            x: 0,
            alpha: 1,
            ease: 'sine.out'
          }, '+=' + .5)
          .to(videoPreview, {
            duration: .5,
            width: collapsedWidth,
            ease: 'sine.out'
          }, '<')
      }

      gsap.set(btnPlay, { autoAlpha: st ? 0 : 1 });
    }


    function showVideo(st) {
      gsap.to(videoHolder, {
        duration: .5,
        autoAlpha: st ? 1 : 0,
        ease: 'sine.out',
        onComplete: () => {
          if (st) player.play();
        }
      });
    }
    
  },

}

window.addEventListener('load', function() {
  BESTPARTNERS.headerScroll();
  BESTPARTNERS.offScreenNav();
  BESTPARTNERS.headerHover();
  BESTPARTNERS.globeSlider();
  BESTPARTNERS.swiperHorizontal();
  BESTPARTNERS.halfSwiperRight();
  BESTPARTNERS.swiperLeft();
  BESTPARTNERS.threeSwiper();
  BESTPARTNERS.offScreenCarosuel2();
  BESTPARTNERS.tabs();
  BESTPARTNERS.typeText();
  BESTPARTNERS.bigPicture();
  BESTPARTNERS.videoExpand();
});

window.addEventListener('scroll', BESTPARTNERS.headerScroll);

